import { Outlet } from 'react-router-dom';
import CookieConsent from './CookieConsent';
import Header from './Header';
import Footer from './Footer';

export default function Layout() {
  return (
    <div className="app">
      <a href="#main-content" className="skip-link">
        İçeriğe atla
      </a>
      <Header />
      <main id="main-content" className="main">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
